var render, staticRenderFns
import script from "./scan_record.vue?vue&type=script&lang=js&"
export * from "./scan_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82b1af96')) {
      api.createRecord('82b1af96', component.options)
    } else {
      api.reload('82b1af96', component.options)
    }
    
  }
}
component.options.__file = "found/views/tpm/views/pay_center/write_off/components/write_off_details/scan_record.vue"
export default component.exports